import { Navigate } from 'react-router-dom';

import { MY_SORARE_NEW } from '@sorare/core/src/constants/__generated__/routes';

const Redirect = () => {
  return <Navigate to={MY_SORARE_NEW} replace />;
};
export default Redirect;
